import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Backdrop from "@material-ui/core/Backdrop";
import { withStyles } from "@material-ui/styles";

import OtpPage from "../common/OtpPage";
import {
  resetRedirection,
  resetRedirectionParams,
  fetchRedirectionParams
} from "../../actions/redirect";
import { fetchCharge } from "../../actions/charge";
import { setPopup, resetPopup } from "../../actions/popup";
import { Target, AuthenticationMode } from "../../model/Charge";
import "./Redirection.css";

const styles = {
  root: {
    zIndex: 9,
    animation: "0.25s ease-out 0s 1 fadeIn"
  }
};

export class Redirection extends React.Component {
  constructor(props) {
    super(props);
    this.formRef = React.createRef();
    const { dispatch } = this.props;
    window.addEventListener("unload", () => {
      dispatch(resetRedirection());
    });
    this.handleInstructionResult = this.handleInstructionResult.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  static getHiddenFields(params) {
    const hiddenFields = [];
    if (!params) return hiddenFields;
    Object.entries(params).forEach(field => {
      hiddenFields.push(
        <input type="hidden" name={field[0]} value={field[1]} key={field[0]} />
      );
    });
    return hiddenFields;
  }

  static getWinOptions() {
    const propertyWidth = 880;
    const propertyHeight = 520;
    const winLeft = (window.screen.width - propertyWidth) / 2;
    const winTop = (window.screen.height - propertyHeight) / 2 - 40;
    return `menubar=no,toolbar=no,location=no,resizable=yes,scrollbars=yes,width=${propertyWidth},height=${propertyHeight},left=${winLeft},top=${winTop}`;
  }

  componentDidMount() {
    const {
      target,
      popupSupport,
      authenticationMode,
      method,
      params,
      url
    } = this.props;

    if (
      authenticationMode === AuthenticationMode.REDIRECTION ||
      authenticationMode === AuthenticationMode.IFRAME
    ) {
      window.addEventListener("message", this.handleInstructionResult);

      const hasParams = params && Object.keys(params).length > 0;
      const isGet = method && method.toUpperCase() === "GET";

      // CASE 1: GET + no params → simple redirect
      if (isGet && !hasParams && target !== Target.IFRAME) {
        window.location.replace(url);
        return;
      }

      if (
        target !== Target.IFRAME &&
        popupSupport &&
        window.location !== window.parent.location
      ) {
        this.formSubmitTimeout = setTimeout(() => {
          this.formRef.current.submit();
        }, 300);
      } else {
        this.formRef.current.submit();
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener("message", this.handleInstructionResult);
    if (this.formSubmitTimeout) clearTimeout(this.formSubmitTimeout);
    if (this.formSubmitTimeout) clearInterval(this.popupInterval);
  }

  handleInstructionResult(messageEvent) {
    const { charge, cardData, dispatch, history, transactionUuid } = this.props;
    const { data } = messageEvent;
    try {
      const messageData = JSON.parse(data);
      if (messageData.eventName === "LYRA_AUTH_INSTRUCTION_RESULT") {
        try {
          // callback call with messageData.value content
          const instructionResult = {
            name: messageData.value.name,
            value: messageData.value.value,
            protocol: messageData.value.protocol
          };

          const cardSubmitData = { ...cardData };
          // eslint-disable-next-line dot-notation
          cardSubmitData["instructionResult"] = instructionResult;
          // eslint-disable-next-line dot-notation
          cardSubmitData["transactionUuid"] = transactionUuid;

          dispatch(
            fetchRedirectionParams(
              charge.uuid,
              cardSubmitData,
              cardSubmitData.type,
              history
            )
          );
        } catch (err) {
          // error callback call
        } finally {
          // always close the iFrame/popin
          dispatch(resetRedirectionParams());
        }
      }
    } catch (err) {
      // process eventual exceptions during callbacks
    }
  }

  handleClose() {
    const { dispatch } = this.props;
    dispatch(resetRedirectionParams());
    dispatch(resetRedirection());
  }

  createPopup() {
    const { charge, dispatch, history } = this.props;
    const winOptions = Redirection.getWinOptions();
    const popup = window.open(
      "/redirect.html",
      "lpg_redirect_popup",
      winOptions
    );
    dispatch(setPopup(popup));
    this.popupInterval = setInterval(() => {
      if (popup.closed) {
        this.handleClose();
        dispatch(resetPopup());
        dispatch(fetchCharge(charge.uuid));
        history.push(`/charge/${charge.uuid}`);
      }
    }, 50);
    return popup;
  }

  render() {
    const {
      method,
      url,
      params,
      target,
      iframeVisible,
      iframeWidth,
      iframeHeight,
      classes,
      charge,
      popupSupport,
      cardData,
      authenticationMode
    } = this.props;
    const hiddenFields = Redirection.getHiddenFields(params);

    let targetToRender;

    if (
      authenticationMode === AuthenticationMode.REDIRECTION ||
      authenticationMode === AuthenticationMode.IFRAME
    ) {
      if (target === Target.IFRAME) {
        const iframeStyle = {
          visibility: iframeVisible ? "visible" : "hidden",
          width: iframeWidth
            ? `${iframeWidth}px`
            : `${window.screen.availWidth}px`,
          height: iframeHeight
            ? `${iframeHeight}px`
            : `${window.screen.availHeight}px`,
          position: "fixed",
          top: "50%",
          left: "50%",
          zIndex: 10,
          backgroundColor: "rgb(255,255,255)",
          animation: "0.25s ease-out 0s 1 slideInTop",
          transform: "translate(-50%, -50%)",
          border: "none"
        };

        targetToRender = (
          <>
            <Backdrop
              open={iframeVisible}
              classes={{ root: classes.root }}
              onClick={this.handleClose}
            />
            <iframe
              id="instructionIframe"
              name="instructionIframe"
              title="instructionIframe"
              style={iframeStyle}
              className={charge.testMode ? "iframe-container" : ""}
            />
            <form
              action={url}
              method={method}
              ref={this.formRef}
              target="instructionIframe"
            >
              {hiddenFields}
            </form>
          </>
        );
      } else {
        let popup;
        if (window.location !== window.parent.location && popupSupport) {
          popup = this.createPopup();
        }

        targetToRender = (
          <form
            action={url}
            method={method}
            ref={this.formRef}
            target={popup ? popup.name : ""}
          >
            {hiddenFields}
          </form>
        );
      }
    } else if (authenticationMode === AuthenticationMode.H2HOTP) {
      targetToRender = cardData ? <OtpPage /> : null;
    }
    return targetToRender;
  }
}

Redirection.propTypes = {
  charge: PropTypes.shape().isRequired,
  method: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  params: PropTypes.object.isRequired,
  target: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
  cardData: PropTypes.shape(),
  history: PropTypes.shape().isRequired,
  transactionUuid: PropTypes.string,
  iframeVisible: PropTypes.bool,
  iframeWidth: PropTypes.number,
  iframeHeight: PropTypes.number,
  classes: PropTypes.shape().isRequired,
  popupSupport: PropTypes.bool.isRequired,
  authenticationMode: PropTypes.string.isRequired
};

Redirection.defaultProps = {
  cardData: undefined,
  transactionUuid: "",
  iframeVisible: false,
  iframeWidth: 0,
  iframeHeight: 0
};

function mapStateToProps({ cardReducer }) {
  return cardReducer;
}

export default withRouter(
  connect(mapStateToProps)(withStyles(styles)(Redirection))
);
